var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input"},[_c('label',{staticClass:"input__label",class:{
      'input__label--hidden': _vm.hideLabel,
      'input__label--disabled': _vm.disabled,
    },attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('input',{ref:"input",class:[
      'input__control',
      `input__control--${_vm.variant}`,
      { 'input__control--error': _vm.hasError },
    ],attrs:{"id":_vm.id,"data-value":_vm.internalValue,"type":_vm.type,"aria-invalid":_vm.hasError,"aria-disabled":_vm.disabled,"disabled":_vm.disabled,"readonly":_vm.readonly,"placeholder":_vm.placeholder},domProps:{"value":_vm.internalValue},on:{"input":_vm.handleOnInput,"change":_vm.handleOnChange}}),(_vm.hasError)?_c('div',{staticClass:"input__error"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }